import { render } from "./Ward.vue?vue&type=template&id=017508fd&scoped=true"
import script from "./Ward.vue?vue&type=script&lang=js"
export * from "./Ward.vue?vue&type=script&lang=js"

import "./Ward.vue?vue&type=style&index=0&id=017508fd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017508fd"]])

export default __exports__